import { ACTION, SUBJECT } from "../../../../constants/permissions";

export const ROLES = [
  {
    value: "Owner",
    permissions: {
      action: ACTION.WRITE,
      subject: SUBJECT.OWNER,
    },
  },
  {
    value: "Admin",
    permissions: {
      action: ACTION.WRITE,
      subject: SUBJECT.ADMIN,
    },
  },
  {
    value: "Billing",
    permissions: {
      action: ACTION.WRITE,
      subject: SUBJECT.ADMIN,
    },
  },
  {
    value: "Technical",
    permissions: {
      action: ACTION.WRITE,
      subject: SUBJECT.ADMIN,
    },
  },
  {
    value: "User",
    permissions: {
      action: ACTION.WRITE,
      subject: SUBJECT.ADMIN,
    },
  },
];

export const DEFAULT_ROLE = "User";
